module.exports = __webpack_public_path__ + "img/GALLERY-VITARA-3.34974ec3.jpg";